export const dashboardConstants = {
    LOADING: 'DASHBOARD_LOADING',
    INITATE: 'DASHBOARD_INITATE',
    SET_SELECTED_SEARCH_HISTORY_INDEX: 'DASHBOARD_SET_SELECTED_SEARCH_HISTORY_INDEX',
    SET_SELECTED_SEARCH: 'DASHBOARD_SET_SELECTED_SEARCH',
    INITATE_SEARCH_HISTORY: 'DASHBOARD_INITATE_SEARCH_HISTORY'
};